'use client'
import React, { useContext, useEffect, useState } from 'react';
import { forwardRef } from '@chakra-ui/system';
import { Select } from 'chakra-react-select';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Button,
} from '@chakra-ui/react';
import { Controller, useForm } from 'react-hook-form';
import { useSharedExperiencesApi } from '../../lib/useSharedExperiencesApi';
import { SharedExperiencesContext } from '../../lib/sharedExperiencesProvider';
import { SharedExperiencePageContext } from '../lib/sharedExperiencePageContext';
import useTranslation from '../../../lib/i18n/useTranslation';

const MoveExperienceInSharedExperienceToGroupForm = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const {
    sharedExperienceId,
  } = useContext(SharedExperiencesContext);
  const {
    experienceGroupList,
    group
  } = useContext(SharedExperiencePageContext);
  const {
    experienceId,
    data,
    hideSave,
    onSubmitted,
    onSubmitting,
    onValidityChange
  } = props;
  const {
    handleSubmit,
    errors,
    control,
    formState: { isSubmitting, isValid }
  } = useForm();
  const sharedExperiencesApi = useSharedExperiencesApi();
  const [groupOptionsList, setGroupOptionsList] = useState(null);
  const [experience, setExperience] = useState(null);
  const onSubmit = async (data) => {
    try {
      if (onSubmitting) {
        onSubmitting();
      }
      const groupId = data.group.value
      await sharedExperiencesApi.moveExperienceToGroup(
        sharedExperienceId,
        experienceId,
        groupId
      );
      if (onSubmitted) {
        onSubmitted();
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    if (experienceGroupList && experienceId) {
      const uniqueGroups = experienceGroupList
        .filter(g => !g.experience_id)
        .filter((g, index, self) => index === self.findIndex(group => group.id === g.id))
        .filter(eg => eg.id !== data?.group_id)
      
      if (uniqueGroups.length > 0) {
        const groupOptionListInGroup = uniqueGroups
          .filter(eg => eg.group_id === group?.group.id && eg.id !== data?.group_id)
          .map(eg => ({ label: eg.name, value: eg.id }))
        const otherGroupsOptionList = uniqueGroups
          .filter(eg => eg.group_id !== group?.group.id && eg.id !== data?.group_id)
          .map(eg => ({ label: eg.name, value: eg.id }))
        setGroupOptionsList([{
          label: "In this group",
          options: groupOptionListInGroup,
        },{
          label: "Other",
          options: otherGroupsOptionList
        },{
          label: "Root",
          options: [{ label: "No Group", value: null }]
        }]);
      } else {
        setGroupOptionsList([{
          label: "Available Groups",
          options: [],
        },{
          label: "Root",
          options: [{ label: "No Group", value: null }]
        }]);
      }
    }
  }, [experienceGroupList, experienceId, data?.group_id, group?.id]);
  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid]);
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} >
        <Controller
          control={control}
          name="group"
          rules={{ required: "Please select a group" }}
          render={({
            field: { onBlur, value, onChange },
          }) => (
            <FormControl isInvalid={errors && errors.group}>
              <FormLabel>{t('group.selectGroup')}</FormLabel>
              <Select
                options={groupOptionsList}
                onBlur={onBlur}
                onChange={onChange}
                value={value}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                chakraStyles={{
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected ? 'text.disable.grey !important' : provided.backgroundColor,
                    color: 'text.dark.grey !important',
                  }),
                }}
              />
              <FormErrorMessage>{errors && errors.group}</FormErrorMessage>
            </FormControl>
          )}
        />
        <Button
          style={{
            display: hideSave ? 'none' : 'inherit',
          }}
          ref={ref}
          isLoading={isSubmitting}
          disabled={!isValid}
          type='submit'
          my={2}
        >Save</Button>
      </form>
    </>
  );
});
export default MoveExperienceInSharedExperienceToGroupForm; 